<template>
  <div class="input-password">
    <input
      v-model="password"
      class="input nds-text-p"
      :class="{'input--error': error}"
      :placeholder="placeholder"
      :type="type"
    >

    <svg-element
      class="icon"
      icon="eye"
      size="20"
      @click="switchType()"
    />
  </div>
</template>

<script>
import SvgElement from '@/components/elements/SvgElement.vue';

const INPUT_TYPE = {
  TEXT: 'text',
  PASSWORD: 'password',
};

export default {
  name: 'InputPasswordElement',
  components: {
    SvgElement,
  },
  props: {
    error: {
      default: false,
      type: Boolean,
    },
    // eslint-disable-next-line vue/prop-name-casing
    modelValue: String,
    placeholder: String,
  },
  emits: [
    'change',
    'update:modelValue',
  ],
  data: () => ({
    type: INPUT_TYPE.PASSWORD,
  }),
  computed: {
    password: {
      get() {
        return this.modelValue;
      },
      set(new_value) {
        this.$emit('update:modelValue', new_value);
        this.$emit('change');
      },
    },
  },
  methods: {
    switchType() {
      this.type = (this.type === INPUT_TYPE.PASSWORD)
        ? INPUT_TYPE.TEXT
        : INPUT_TYPE.PASSWORD;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';

.input-password {
  height: 38px;
  position: relative;
  width: 100%;
}

.input {
  border: 1px solid $blue-haze;
  border-radius: 8px;
  height: 38px;
  outline: none;
  padding: 10px 8px;
  width: 100%;

  &::-webkit-input-placeholder {
    color: $amethyst-smoke;
  }

  &::-moz-placeholder {
    color: $amethyst-smoke;
  }

  &::-ms-placeholder {
    color: $amethyst-smoke;
  }

  &::placeholder {
    color: $amethyst-smoke;
  }

  &:focus {
    border: 1px solid $cornflower-blue;
  }

  &--error {
    border: 1px solid $geraldine !important;
  }
}

.icon {
  --color: #{$blue-haze};
  cursor: pointer;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);

  &:hover {
    --color: #{$cornflower-blue};
  }
}
</style>
